module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-recaptcha/bra-recaptcha.component.html
// module id = ../../../../../src/app/componentes/bra-recaptcha/bra-recaptcha.component.html
// module chunks = main